export default __webpack_public_path__ + "static/media/visa-icon.e18762c6.svg";